import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import _ from "lodash";
import Loading from "../../loading";

class ProjectsExport extends Component{
	render(){
		return [
			<p key="export">
				<button type="button" className="button is-small is-inm-purple" onClick={() => this._showModal()}><b>Exportar</b></button>
			</p>,
			this.state.optionsModalShow ?
				<OptionsModal key="modal-export" active={this.state.optionsModalShow} closeModal={() => this._toggleModal()} {...this.props}/> :''
		]
	}

	constructor(){
		super();
		this.state = {
			optionsModalShow: false
		}
	}

	_showModal(){
		this.setState({
			optionsModalShow: true
		});
	}

	_toggleModal() {
		this.props.reset('projects.options');
		this.setState({
			optionsModalShow: false
		});
	}
}

class OptionsModal extends Component {
	render(){
		const {projects/*, modalities, versions*/} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Opciones para exportar</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					{projects.isFetching ? <Loading/>:
						<div className="modal-card-body">
							<div className="field is-grouped is-grouped-multiline">
								<div className="control">
									<div className="message is-info">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="projects_data" className="checkbox">
														<input type="checkbox" name="projects_data" id="projects_data" className="checkbox" checked={this.state.projects_data} onChange={this._addOptions} disabled={this.state.all_options}/>
														<span style={{whiteSpace:'normal'}}> Datos proyecto </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<div className="message is-info">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="projects_agency" className="checkbox">
														<input type="checkbox" name="projects_agency" id="projects_agency" className="checkbox" checked={this.state.projects_agency} onChange={this._addOptions} disabled={this.state.all_options}/>
														<span style={{whiteSpace:'normal'}}> Datos Instancia </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<div className="message is-info">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="projects_owner" className="checkbox">
														<input type="checkbox" name="projects_owner" id="projects_owner" className="checkbox" checked={this.state.projects_owner} onChange={this._addOptions} disabled={this.state.all_options}/>
														<span style={{whiteSpace:'normal'}}> Datos Titular </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<div className="message is-info">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="projects_goals" className="checkbox">
														<input type="checkbox" name="projects_goals" id="projects_goals" className="checkbox" checked={this.state.projects_goals} onChange={this._addOptions} disabled={this.state.all_options}/>
														<span style={{whiteSpace:'normal'}}> Datos Metas </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="control">
									<div className="message is-info">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="projects_expenses" className="checkbox">
														<input type="checkbox" name="projects_expenses" id="projects_expenses" className="checkbox" checked={this.state.projects_expenses} onChange={this._addOptions} disabled={this.state.all_options}/>
														<span style={{whiteSpace:'normal'}}> Datos Gastos </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

                                <div className="control">
                                    <div className="message is-info">
                                        <div className="message-body">
                                            <div className="field">
                                                <div className="control">
                                                    <label htmlFor="projects_version_phases_groups" className="checkbox">
                                                        <input type="checkbox" name="projects_version_phases_groups" id="projects_version_phases_groups" className="checkbox" checked={this.state.projects_version_phases_groups} onChange={this._addOptions} disabled={this.state.all_options}/>
                                                        <span style={{whiteSpace:'normal'}}> Procesos </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
							</div>

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-danger" onClick={this.props.closeModal}>
										Cerrar
									</button>
								</div>
								<div className="control">
									<button type="button" className="button is-inm-purple" onClick={() => this._getExport()} disabled={this._validExport()}>
										Exportar
									</button>
								</div>
							</div>
							<div className="field is-grouped is-grouped-right">
								{projects.filters.modality_id ? '':
									<control><small className="help has-text-danger">Modalidad requerida</small></control>}
								<div className="control"></div>
								{projects.filters.version_id ? '':
									<control><small className="help has-text-danger">Versión requerida</small></control>}
							</div>
						</div>}
				</div>
			</div>
		)
	}

	componentWillMount(){
		let options = [];
		_.forEach(this.state, (value, key)=> {
			if(value===true) options.push(key);
		});
        this.props.change('projects.options', options)

		/*
		this.props.change('projects.options',[
			'projects_data',
			'projects_agency',
			'projects_owner',
			'projects_goals',
			'projects_expenses',
			'projects_version_phases_groups'
		])
		*/
	}

	constructor(props) {
		super(props);
		this.state = {
			projects_data: true,
			projects_agency: true,
			projects_owner: true,
			projects_goals: false,
			projects_expenses: false,
            projects_version_phases_groups: false
		}
		this._addOptions = this._addOptions.bind(this);
	}

	_getExport(){
		const { projects } = this.props;
		this.props.projectsExport(projects.filters, projects.options);
	}

	_addOptions(event){
		let {projects} = this.props;

		if(event.target.checked){
			this.props.add('projects.options', event.target.name);
			this.setState({
				[event.target.name]: true
			})
		}else {
			let optionIndex = _.findIndex(projects.options, (o) => o === event.target.name);
			this.props.remove('projects.options',optionIndex);
			this.setState({
				[event.target.name]: false
			})
		}
	}

	_validExport(){
		let {projects} = this.props;
		let response = false;

		if(projects.filters.modality_id && projects.filters.version_id){
			/*if(this.state.all_options){
				response = false;
			}else */
			if(!_.isEmpty(projects.options)){
				response = false;
			}else {
				response = true;
			}
		}else {
			response = true;
		}

		return response;
	}

}

export default SecureLayout(ProjectsExport);


// WEBPACK FOOTER //
// ./src/elements/projects/widgets/projects_export.jsx